/* Dear eM – em-card-msg.js (v26.2 · 23/10/2026, Claude)
 * Lời chúc trên thiệp: dearem-store.js lưu "Lời chúc" đã TỰ XUỐNG DÒNG mỗi 30 ký tự → trong đơn không phân biệt
 * được chỗ khách tự bấm Enter. File này ghi đè giá trị gửi vào giỏ:
 *   - giữ nguyên chữ khách gõ, bỏ xuống dòng tự động;
 *   - chỗ khách bấm Enter: thêm " ↵" ở cuối dòng rồi xuống dòng (dòng trống liên tiếp gộp lại 1).
 * Áp dụng cả trang thiệp (ô ẩn properties[Lời chúc]) và nút "+ Viết lời chúc" ở trang SP / giỏ hàng (/cart/add.js).
 * Nạp từ snippets/em-customizer-patch.liquid (trang sản phẩm + giỏ hàng). Không sửa dearem-store.js.
 */
(function () {
  'use strict';
  if (window.__emCardMsg) return; window.__emCardMsg = 1;
  var PROP = 'Lời chúc';
  function fmt(raw) {
    var ps = String(raw || '').replace(/\r/g, '').split('\n').map(function (p) { return p.replace(/[ \t]+/g, ' ').trim(); });
    while (ps.length && !ps[0]) ps.shift();
    while (ps.length && !ps[ps.length - 1]) ps.pop();
    ps = ps.filter(function (p, i) { return p || ps[i - 1]; });
    return ps.join(' ↵\n');
  }
  window.DearEmCardMsg = { format: fmt };

  /* 1) trang thiệp: ô ẩn trong form
   * Lỗi cũ (phát hiện 23/10): dearem-store.js tìm form bằng form[id^="product-form-"] → trúng form TRẢ GÓP (installment) ở khối giá,
   * nên ô ẩn "Lời chúc" nằm sai form → thêm thiệp từ trang thiệp vào giỏ KHÔNG có lời chúc, và không chặn khi bỏ trống.
   * Sửa: chuyển ô ẩn (và ô nhập trên máy tính) vào đúng form thêm giỏ của product-form; chặn thêm giỏ khi chưa nhập lời chúc. */
  function realForm() { return document.querySelector('product-form form[action*="/cart/add"]'); }
  function syncPDP() {
    var hid = document.querySelector('input[type="hidden"][name="properties[' + PROP + ']"]');
    var host = document.querySelector('.dmc-pdp'), ta = host && host.querySelector('[data-dmc-input]');
    if (!hid || !ta) return;
    var f = realForm();
    if (f && !f.contains(hid)) f.appendChild(hid);
    if (f && !f.contains(host) && !host.closest('.tt-sheet')) {
      var btns = f.querySelector('.product-form__buttons') || f.lastElementChild;
      f.insertBefore(host, btns);
    }
    var v = fmt(ta.value); if (hid.value !== v) hid.value = v;
  }
  document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('.dmc-pdp [data-dmc-input]')) setTimeout(syncPDP, 0); }, false);
  document.addEventListener('submit', function (e) {
    syncPDP();
    var f = realForm(), hid = document.querySelector('input[type="hidden"][name="properties[' + PROP + ']"]'), host = document.querySelector('.dmc-pdp');
    if (!f || e.target !== f || !hid || !host) return;
    if (!hid.value) {
      e.preventDefault(); e.stopImmediatePropagation();
      var l = host.querySelector('[data-dmc-lines]'); if (l) { l.className = 'bad'; l.textContent = 'Bạn nhập lời chúc cho thiệp nhé'; }
      var ta = host.querySelector('[data-dmc-input]'); if (ta) { try { ta.scrollIntoView({ block: 'center' }); } catch (x) {} ta.focus(); }
    }
  }, true);
  /* nút Mua ngay / Thêm vào giỏ có thể gọi thẳng /cart/add bằng FormData → chèn lời chúc nếu thiếu */
  setInterval(syncPDP, 600);

  /* 2) thêm nhanh thiệp (trang SP / giỏ hàng): sửa giá trị trong request /cart/add.js */
  var of = window.fetch;
  if (of && !of.__emCard) {
    var nf = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?/.test(url) && init && typeof init.body === 'string' && init.body.indexOf(PROP) > -1) {
          var ta = document.querySelector('.dmu .dmc-msg [data-dmc-input]') || document.querySelector('.dmc-msg [data-dmc-input]');
          var b = JSON.parse(init.body);
          (b.items || []).forEach(function (it) { if (it.properties && it.properties[PROP] != null && ta) it.properties[PROP] = fmt(ta.value); });
          init = Object.assign({}, init, { body: JSON.stringify(b) });
        }
        /* thêm giỏ từ trang thiệp bằng FormData (Mua ngay / Thêm vào giỏ): bảo đảm có lời chúc */
        var hid = document.querySelector('input[type="hidden"][name="properties[' + PROP + ']"]');
        if (/\/cart\/add/.test(url) && init && typeof FormData !== 'undefined' && init.body instanceof FormData && hid && hid.value) {
          var k = 'properties[' + PROP + ']';
          if (!init.body.get(k)) init.body.set(k, hid.value);
        }
      } catch (e) {}
      return of.call(this, input, init);
    };
    nf.__emCard = 1;
    Object.keys(of).forEach(function (k) { try { nf[k] = of[k]; } catch (e) {} });
    window.fetch = nf;
  }
})();
